module.exports = __webpack_public_path__ + "img/btn_up.5fba0ce3.svg";